import * as React from 'react';

type Props = React.PropsWithChildren<{
    onError?: (error:any) => void
}>

type State = {
    hasError: boolean
}

export default class RenderErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error: any) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error: any, info: any) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      //console.log(error);
      this.props.onError && this.props.onError(error)
    }
  
    render() {
      if (this.state.hasError) {
        return null;
      }
  
      return this.props.children;
    }
}